module.exports = __webpack_public_path__ + "static/media/hel-4.39ec2f14.gif";